import cinecito from "../assets/img/proyectImg/cinecito.png";
import pSneakers from "../assets/img/proyectImg/plataformaSn.png";
import nGlobal from "../assets/img/proyectImg/netGlobal.png";
import gpsAdmin from "../assets/img/proyectImg/gpsAdmin.png";
import gpsMob from "../assets/img/proyectImg/gps1.png";
import simpleCom from "../assets/img/proyectImg/simpleCom.png";
import sativa from "../assets/img/proyectImg/sativa.png";

const listaProyectos = [
  {
    title: "CINECITO",
    imgUrl: cinecito,
    description:
      "Catalogo web de películas. Es posible registrarse, filtrar por nombre, año, calificación y género. El usuario tiene acceso a la vista individual de cada una donde tiene toda la informacion de la misma. Tambien es posible agregarlas a favoritos.",
    stack: ["HTML5", "CSS5", "JAVA SCRIPT", "NODE", "BOOTSTRAP", "REACT", "SEQUELIZE", "PASSPORT"],
    git: "https://github.com/fede8932/checkpoint-TMDB-220101.git",
    build: "",
    type: "Académico",
  },
  {
    title: "PLATAFORMA SNEAKERS",
    imgUrl: pSneakers,
    description:
      "Plataforma Sneakers es un E-commerce hecho desde cero en grupo como práctica para el coding-Bootcamp de Plataforma 5, cumple con las funcionalidades básicas de una E-commerse. Mi rol principal fue front-end con React desarrollando las vistas pincipales como lo son, el paginado de productos, vista de un producto en particular, funcionalidades de dejar y ver reviews, buscador, entre otras cosas.",
    stack: ["HTML5", "CSS5", "JAVA SCRIPT", "NODE", "EXPRESS", "BULMA", "REACT", "REDUX", "PASSPORT", "POSTGRES"],
    git: "https://github.com/fede8932/E-commerce.git",
    build: "",
    type: "Académico",
  },
  {
    title: "NET-GLOBAL",
    imgUrl: nGlobal,
    description:
      "Aplicacion web para una empresa de seguridad. Cuenta con una web app para el admin, el cual tiene la capacidad de registrar adminitradores y vigiladores, clientes y sucuarsales. Tambien con una PWA que se para el movil del vigilador y le da la posibilidad de registrar ingresos y egresos geolocalizados, consultar calendario de servicios, llevar un control de las horas trabajadas y dar avisos de ausencias.",
    stack: ["HTML5", "CSS5", "JAVA SCRIPT", "NODE", "EXPRESS", "BOOTSTRAP", "REACT", "REDUX", "POSTGRES", "PWA", "NODEMAILER","REACT LEAFLET"],
    git: "https://github.com/fede8932/net-global.git",
    build: "",
    type: "Freelance",
  },
  {
    title: "GPS SOLUTION APP",
    imgUrl: gpsMob,
    description:
      "Es una plataforma de rastreo satelital. Esta parte consta de una aplicación MOBILE para el cliente. Es posible el seguimiento en tiempo real de las unidades registradas, se puede hacer un seguimiento del calendario de pagos y calendario de mantenimiento de la unidad, consultar los recorridos por fecha, asignar velocidad maxima y zonas seguras. Entre otras funciones",
    stack: ["JAVA SCRIPT", "NODE", "EXPRESS", "REACT NATIVE CLI", "REDUX", "MONGO DB", "MAPBOX", "OPEN STREET MAP", "FIGMA"],
    git: "https://github.com/fede8932/gpsSolution.git",
    build: "",
    type: "Proyecto personal",
  },
  {
    title: "GPS SOLUTION",
    imgUrl: gpsAdmin,
    description:
      "Es una plataforma de rastreo satelital. Esta parte consta de una aplicación web para el administrador. Es posible agregar clientes, vehiculos y asignarselos. Tambien agregar dispositivos se rastreo y vincularlos con las unidades. Además del seguimiento en tiempo real de la unidad, se puede hacer un seguimiento del calendario de pagos del cliente y se le puede brindar soporte por mensajería",
    stack: ["HTML5", "SASS", "JAVA SCRIPT", "NODE", "EXPRESS", "BOOTSTRAP", "REACT", "REDUX", "POSTGRES", "LEAFLET", "OPEN STREET MAP", "FIGMA"],
    git: "https://github.com/fede8932/gpsSolution.git",
    build: "https://gpssolution.netlify.app/",
    type: "Proyecto personal",
  },
  {
    title: "SIMPLE COMERCIO",
    imgUrl: simpleCom,
    description:
      "Simple comercio es un emprendimiento innovador de base tecnológica, comprometido en brindar respuestas a problemáticas sociales y ambientales a través de un modelo económicamente sostenible.",
      stack: ["HTML5", "CSS5", "JAVA SCRIPT", "NODE", "BOOTSTRAP", "VUE", "EXPRESS", "RABBIT MQ", "DOCKER", "MONGO DB"],
    git: "",
    build: "https://simplecomercio.com/",
    type: "Freelance",
  },
  {
    title: "SATIVA COMERCIO",
    imgUrl: sativa,
    description:
      "Sativa comercio es un comercio electrónico que funciona como nexo entre comprador y vendedor. Consta de una app web, una mobile y un poderoso backend basado en microservicios. Funciona con APIs de terceros, como Pedidos Ya, Treggo y Mercado Pago",
      stack: ["HTML5", "SASS", "JAVA SCRIPT", "NODE", "BOOTSTRAP", "REACT", "PWA", "EXPRESS", "RABBIT MQ", "DOCKER", "MONGO DB", "POSTGRES"],
    git: "https://github.com/fede8932/SativaFork.git",
    build: "",
    type: "Freelance",
  },
];

export default listaProyectos.reverse();
